import { render } from "./data.vue?vue&type=template&id=49c94193"
import script from "./data.vue?vue&type=script&lang=js"
export * from "./data.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__